import { useEffect, useRef } from "react";

export default function useInterval(callback: any, delay: number) {
    const savedCallback = useRef(callback);

    useEffect(() => {
        savedCallback.current = callback;
    });

    useEffect(() => {
        function tick() {
            if (typeof savedCallback?.current !== "undefined") {
                (savedCallback as any).current();
            }
        }
        if (delay !== null && savedCallback?.current) {
            const id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay]);
}
